import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import '@/commons/styles/table.less';
import '@/commons/styles/modal.less';
import { ConfigProvider } from 'antd';
import { UploadFileState, DownloadState, useUploadService, useDownloadService, UploadPanel, DownloadPanel } from 'tncet-common';
import { SideStatus, useSideService } from './commons/context/side-store';
import { SystemStatus, useSystemService } from './commons/context/system-store';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { checkFileExists, getFileUploadUrl } from './api/project/file';
import zhCN from 'antd/lib/locale/zh_CN'
import { StoreyStatus, useStoreyService } from './commons/context/storey-store';
import ProjectLayout from './layout/project';
import { CommonTabbarState, useCommonTabbarService } from './commons/components/common-tabbar';
import '@/commons/styles/table.less';
import { StructureStatus, useStructureService } from './commons/context/structure-store';
import { HavcStatus, useHavcService } from './commons/context/havc-store';
import { useFeedbackUploadService, UserFeedbackUploadFileState } from './commons/components/user-feedback/upload-panel';
import UserFeedBackPanel from './commons/components/user-feedback';
import DesktopLayout from './layout/desktop';
import mitt from "mitt";
import LoginMain from './layout/login';
import { getUsersCheckLogin } from './api/project/user';
import { User } from './commons/interface/project/user';
import localStore from './commons/store/local-store';


export const emitter = mitt();
export const SystemContext = React.createContext<SystemStatus>(null);
export const UploadFileContext = React.createContext<UploadFileState>(null);
export const DownloadContext = React.createContext<DownloadState>(null);
export const StoreyContext = React.createContext<StoreyStatus>(null);
export const SideContext = React.createContext<SideStatus>(null);
export const StructureContext = React.createContext<StructureStatus>(null);
export const HavcContext = React.createContext<HavcStatus>(null);
export const CommonTabbarContext = React.createContext<CommonTabbarState>(null);
export const UserFeedbackUploadFileContext = React.createContext<UserFeedbackUploadFileState>(null);

export const loginUrl = process.env.NODE_ENV === 'development' ?
    `http://localhost:3002/login` :
    `http://account.${document.domain.split('.').slice(-2).join('.')}/login`;

function App() {
    const navigate = useNavigate();
    const location = useLocation();
    const systemContext = useSystemService();
    const targetUrlRef = useRef<string>(loginUrl);

    const [visible, setVisible] = useState(false);  // 意见反馈弹窗

    useEffect(() => {
        targetUrlRef.current = `${loginUrl}?target=${encodeURIComponent(window.location.href)}`
    }, [location])

    useEffect(() => {
        let timer$ = setInterval(() => {
            checkLogin();
        }, 60000)
        return (() => {
            clearInterval(timer$);
        })
    }, [])

    const checkLogin = () => {
        if (!localStore.userUuid) return;
        getUsersCheckLogin().then(res => {
            if (res.status === 200) {
                let user: User = res.data;
                localStore.userUuid = user.uuid;
                localStore.setUser(user);
            }
        }).catch(err => {
            localStore.clear();
            navigate("/login");
        })
    }

    return (
        <ConfigProvider
            locale={zhCN}
            theme={{
                components: {
                    Radio: {
                        dotSize: 10,
                        radioSize: 14,
                        buttonPaddingInline: 8,
                        wrapperMarginInlineEnd: 4,
                    },
                },
            }}
        >
            <CommonTabbarContext.Provider value={useCommonTabbarService()}>
                <SystemContext.Provider value={systemContext}>
                    <StructureContext.Provider value={useStructureService()}>
                        <HavcContext.Provider value={useHavcService()}>
                            <UploadFileContext.Provider value={useUploadService()}>
                                <DownloadContext.Provider value={useDownloadService()}>
                                    <StoreyContext.Provider value={useStoreyService()}>
                                        <SideContext.Provider value={useSideService()}>
                                            <UserFeedbackUploadFileContext.Provider value={useFeedbackUploadService()}>
                                                {/* <ProjectMain /> */}
                                                <div className="tn-base">
                                                    <Routes>
                                                        <Route path='/login' element={<LoginMain />} />
                                                        <Route path='/desktop/*' element={<DesktopLayout feedbackVisible={visible} changeFeedbackVisible={(value) => setVisible(value)} />} />
                                                        <Route path='/project/:projectUuid/model/:modelUuid/branch/:branchUuid/*' element={<ProjectLayout feedbackVisible={visible} changeFeedbackVisible={(value) => setVisible(value)} />} />
                                                        <Route path='/project/:projectUuid/model/:modelUuid/*' element={<ProjectLayout feedbackVisible={visible} changeFeedbackVisible={(value) => setVisible(value)} />} />
                                                        <Route path='/project/:projectUuid/*' element={<ProjectLayout feedbackVisible={visible} changeFeedbackVisible={(value) => setVisible(value)} />} />
                                                        <Route path="*" element={<Navigate to="/login" />} />
                                                    </Routes>
                                                    <div className='upload-download-panel'>
                                                        <UploadPanel checkFileExists={checkFileExists} getUploadUrl={getFileUploadUrl} uploadContext={UploadFileContext} />
                                                        <DownloadPanel downloadContext={DownloadContext} />
                                                    </div>
                                                </div>
                                                <UserFeedBackPanel visible={visible} changeVisible={(value) => setVisible(value)} />
                                            </UserFeedbackUploadFileContext.Provider >
                                        </SideContext.Provider>
                                    </StoreyContext.Provider>
                                </DownloadContext.Provider>
                            </UploadFileContext.Provider>
                        </HavcContext.Provider>
                    </StructureContext.Provider>
                </SystemContext.Provider>
            </CommonTabbarContext.Provider>
        </ConfigProvider>
    );
}

export default App;
